<template lang="pug">
.width-100
  .list.kimple-scroll(v-if='fromProgram')
    .row.middle
      checkbox.m-right-1(:checked='allContentSelected' :updateCheck='toggleUsedContent')
      label.text-normal {{ programName }}
    .resource(v-for='resource in resources' :key='resource.id')
      .row.middle
        checkbox.m-right-1(
          :checked='allContentSelected || isResourceSelected(resource.id)'
          :updateCheck='() => toggleUsedResource(resource.id)'
        )
        label.text-normal {{ resource.title }}
        button.m-left-auto(v-if='resource.classPlans' @click='toggleActiveResourceClasses(resource.id)')
          simple-svg(:filepath='arrowDown' width='18px' height='18px')
      .resource-classes.m-left-3.m-top-1.column(v-if='resource.classPlans && activeResourceIds.includes(resource.id)')
        .class.row.middle(v-for='resClass in sortClass(resource.classPlans)' :key='resClass.classId')
          checkbox.m-right-1(
            :checked='allContentSelected || isClassSelected(resClass.id, resource.id)'
            :updateCheck='() => toggleUsedClass({classId: resClass.id, resourceId: resource.id})'
          )
          label.text-normal(v-if='resClass.name')
            | {{ $t("registerUseModal.contentList.classWithName", {classNumber: resClass.classNumber, name: resClass.name}) }}
          label.text-normal(v-else)
            | {{ $t("registerUseModal.contentList.class", {classNumber: resClass.classNumber}) }}
  .list.kimple-scroll(v-else)
    .row.middle
      checkbox.m-right-1(:checked='allResourceSelected' :updateCheck='toggleUsedContent')
      label.text-normal {{ resources[0].title }}
    .resource-classes.m-top-1.column(v-if='resources[0].classPlans')
      .class.row.middle(
        v-if='resources[0].classPlans'
        v-for='resClass in sortClass(resources[0].classPlans)'
        :key='resClass.classId'
      )
        checkbox.m-right-1(
          :checked='allResourceSelected || isClassSelected(resClass.id, resources[0].id)'
          :updateCheck='() => toggleUsedClass({classId: resClass.id, resourceId: resources[0].id})'
        )
        label.text-normal(v-if='resClass.name')
          | {{ $t("registerUseModal.contentList.classWithName", {classNumber: resClass.classNumber, name: resClass.name}) }}
        label.text-normal(v-else)
          | {{ $t("registerUseModal.contentList.class", {classNumber: resClass.classNumber}) }}
  .row.m-top-auto
    button.primary-button.m-left-auto(@click='$emit("next")' :disabled='!contentSelected')
      | {{ $t("registerUseModal.next") }}
</template>

<script>
import Checkbox from '@/components/Inputs/Checkbox'
import arrowDown from '@/assets/ic_chevron-down.svg'
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    fromProgram: { type: Boolean }
  },
  components: { Checkbox },
  data() {
    return {
      arrowDown,
      activeResourceIds: []
    }
  },
  computed: {
    ...mapState({
      resources: state => state.registerUse.resources,
      programId: state => state.registerUse.programId,
      programName: state => state.registerUse.programName
    }),
    allContentSelected() {
      return Boolean(this.resources.every(res =>
        res.used || (res.classPlans && res.classPlans.every(resClass => resClass.used))
      ))
    },
    allResourceSelected() {
      const resource = this.resources[0]
      return resource.used || (resource.classPlans && resource.classPlans.every(resClass => resClass.used))
    },
    contentSelected() {
      return Boolean(
        this.resources.some(res => res.used || (res.classPlans && res.classPlans.some(resClass => resClass.used)))
      )
    }
  },
  methods: {
    ...mapActions([
      'toggleUsedContent',
      'toggleUsedResource',
      'toggleUsedClass'
    ]),
    sortClass(classPlan) {
      return classPlan.map(cl => cl).sort((a, b) => a.classNumber - b.classNumber)
    },
    toggleActiveResourceClasses(id) {
      if (this.activeResourceIds.includes(id)) {
        this.activeResourceIds = this.activeResourceIds.filter(resId => resId !== id)
      } else {
        this.activeResourceIds = [...this.activeResourceIds, id]
      }
    },
    isResourceSelected(resourceId) {
      const resource = this.resources.find(res => res.id === resourceId)
      return Boolean(resource.used || (resource.classPlans && resource.classPlans.every(resClass => resClass.used)))
    },
    isClassSelected(classId, resourceId) {
      const resource = this.resources.find(res => res.id === resourceId)
      return Boolean(resource && resource.classPlans.find(resClass => resClass.id === classId).used)
    }
  }
}
</script>

<style lang="scss" scoped>

.list,.resources{
  &>:not(:last-child) {
    margin-bottom: 25px;
  }
}
.resource-classes{
  &>:not(:last-child){
    margin-bottom: 10px;
  }
}

.list{
  height: 280px;
  overflow-y: auto;
  padding-right: 10px;
}
</style>
